"use client";

import { Flex, Input, Text } from "@chakra-ui/react";
import SearchInput from "./SearchInput";

const fs = "sm";

export const CardRegistration = ({
  value,
  onChange,
  type,
  CompIp,
  disabled,
  searchic,
}) => {
  const onChangeIp = (v) => {
    if (!onChange) {
      return;
    }
    if (v?.trim) {
      v = v?.trim();
      if (v?.replaceAll) {
        v = v.replaceAll(" ", "");
      }
      if (v?.toUpperCase) {
        v = v.toUpperCase();
      }
    }
    onChange(v);
  };

  if (type === "comp" || type === "search") {
    return (
      <Flex
        overflow={"hidden"}
        borderRadius={8}
        borderWidth={2}
        borderColor={"fontdark"}
        w={"9rem"}
      >
        <Flex
          direction={"column"}
          bg={"blue"}
          pl={"0.5rem"}
          pr={"0.5rem"}
          minH={"2.2rem"}
          justify={"center"}
          overflow={"hidden"}
        >
          <Text color={"yellow"} fontWeight={"bold"} textStyle={fs}>
            GB
          </Text>
        </Flex>
        <Flex
          direction={"column"}
          bg={"yellow"}
          flex={1}
          overflow={"hidden"}
          justify={"center"}
        >
          {/* <InputComp
            value={value}
            onChange={onChangeIp}
            type={type === "search" ? "search" : "text"}
          /> */}
          {disabled ? (
            <Text pl={"0.6rem"} color={"#000"} textStyle={fs} fontWeight={'extrabold'}>
              {value}
            </Text>
          ) : type === "search" ? (
            <SearchInput
              type={"search"}
              value={value}
              onChange={onChangeIp}
              fontWeight={"extrabold"}
              disabled={disabled ? true : false}
              color={"#000"}
              focusRingColor="transparent"
              borderColor={"transparent"}
              searchi={searchic}
            />
          ) : (
            <Input
              focusRingColor="transparent"
              type="text"
              textStyle={"sm"}
              value={value}
              onChange={(e) => onChangeIp(e.target.value)}
              disabled={disabled ? true : false}
              color={"fontdark"}
              borderColor={"transparent"}
            />
          )}
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex
      overflow={"hidden"}
      borderRadius={8}
      borderWidth={2}
      borderColor={"fontdark"}
      w={"9rem"}
    >
      <Flex direction={"column"} bg={"blue"} p={'0.5rem'} justify={"center"}>
        <Text color={"yellow"} fontWeight={"bold"} textStyle={fs}>
          GB
        </Text>
      </Flex>
      <Flex direction={"column"} bg={"yellow"} w={"100%"}>
        {disabled ? (
          <Text pl={"0.6rem"} color={"fontdark"} textStyle={fs}>
            {value}
          </Text>
        ) : (
          <Input
            onChange={(e) => {
              if (onChange) {
                let val = e.currentTarget.value;
                if (val?.trim) {
                  val = val?.trim();
                  if (val?.replaceAll) {
                    val = val.replaceAll(" ", "");
                  }
                  if (val?.toUpperCase) {
                    val = val.toUpperCase();
                  }
                }
                onChange(val);
              }
            }}
            value={value}
            fontWeight={"bold"}
            textStyle={"sm"}
            borderColor={"transparent"}
            color={"fontdark"}
          />
        )}
      </Flex>
    </Flex>
  );
};
